import TestsPage from "../components/tests-page";
import elabAPI from "../../libs/api/elab";
import React, { useState, useEffect } from "react";
import { FloatingMenu } from "../components/floating-menu";
import { UpgradePopup } from "../components/upgrade-popup";
import { FloatingHelpButton } from "../components/floating-help-button";
import { LearnMorePage } from "../components/learn-more-page";

export default function Home() {
  const [currentPage] = useState("tests");
  const [testsData, setTestsData] = useState(null);
  const [activeSection, setActiveSection] = useState("tests");
  const [selectedLevel, setSelectedLevel] = useState("B1");
  const [isHelpOpen, setIsHelpOpen] = useState(false)
  const [isUpgradePopupOpen, setIsUpgradePopupOpen] = useState(false);
  const Upgradetoggle = () => setIsUpgradePopupOpen(!isUpgradePopupOpen);

  useEffect(() => {
    const fetchTests = async () => {
      try {
        const response = await elabAPI.getAvailableTests();
        const data = await response.json();
        const transformedData = data.level_tests.reduce((acc, level_data) => {
          const levelKey = level_data.level;

          acc[levelKey] = {
            title: level_data.title,
            subtitle: level_data.subtitle,
            tests: level_data.tests,
          };
          return acc;
        }, {});

        setTestsData(transformedData);
      } catch (error) {
        console.error("Error fetching available tests:", error);
      }
    };

    fetchTests();
  }, []);

  const handleHelp = () => {
    setIsHelpOpen(true)
  }

  if (isHelpOpen) {
    return <LearnMorePage onBack={() => setIsHelpOpen(false)} />
  }

  return (
    <div>
      <FloatingMenu
        activeSection={activeSection}
        onSectionChange={setActiveSection}
        selectedLevel={selectedLevel}
        onLevelChange={(level) => setSelectedLevel(level)}
        Upgradetoggle={Upgradetoggle}
      />
      <FloatingHelpButton onClick={handleHelp} />
      {testsData && currentPage === "tests" && (
        <TestsPage
          testsData={testsData}
          selectedLevel={selectedLevel}
          activeSection={activeSection}
          onSectionChange={setActiveSection}
          Upgradetoggle={Upgradetoggle}
        />
      )}
      <UpgradePopup
        toggle={Upgradetoggle}
        isOpen={isUpgradePopupOpen}
        level={selectedLevel}
      />
    </div>
  );
}
